module.exports = __webpack_public_path__ + "static/media/cccb_brett.1cc61166.jpg";